var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright"},[_c('cms-text',{attrs:{"value":"copyright_text","props":{ color: 'secondary', tag: 'span'},"layout":""}}),_c('span',[_vm._v(" - Created by:")]),_c('base-link',{attrs:{"underline":"","type":"gold","url":"https://www.rekinysukcesu.pl/"}},[_vm._v(" Marketing Agency ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }